import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import '../index.scss'
import WriterCardEditable from '@Components/Cards/WorkDetailCards/WriterCards/WriterCardEditable'
import { writersInvalidCheck } from '@App/helpers/work-entities/entities-validators'
import { writerRemover } from '@App/helpers/work-entities/removers'
import { StoresContext } from '@App/contexts'
import { Navigate } from 'react-router'
import { isComposerPresent } from '@App/helpers/work-entities/fields-validators'
import RootStore from '@App/stores/root-store'
import { WriterModel } from '@Entities/work/writer-model'

const WritersSharesRoleStep = () => {
    const { workStore, libStore, rightsholderStore } = useContext<RootStore>(StoresContext)

    const removeWriter = (removingWriter: WriterModel) => {
        const workDraftFromLocal = workStore.workDraftLocal

        if (!workDraftFromLocal) {
            return
        }

        const updatedWorkDraft = writerRemover(removingWriter, workDraftFromLocal)

        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const stepValidator = () => {
        const workDraftFromLocal = workStore.workDraftLocal

        if (!workDraftFromLocal) {
            return
        }

        const invalid = writersInvalidCheck(
            workDraftFromLocal.writers,
            libStore.writerRoles,
            workDraftFromLocal.isComplete
        )

        workStore.setWizardStepValidation(!invalid)
    }

    useEffect(() => {
        stepValidator()
    }, [workStore.workDraftLocal])

    const currentRhId = rightsholderStore.currentRightsholderId
    const workDraftFromLocal = workStore.workDraftLocal

    if (!workDraftFromLocal || !currentRhId) {
        return null
    }

    const typeCreator = location.href.split('/')[7] // HARD CODE

    if (!workDraftFromLocal.writers.length) {
        if (workDraftFromLocal.id) {
            return (
                <Navigate
                    to={`/rightsholder/${currentRhId}/catalog/${workDraftFromLocal.isComplete ? 'catalog' : 'draft'}/${
                        workDraftFromLocal.id
                    }/edit/writers`}
                />
            )
        }

        return <Navigate to={`/rightsholder/${currentRhId}/create-work/manual/${typeCreator}/writers`} />
    }
    return (
        <div className="writers-step">
            <div className="step-content">
                <div className="main-title">
                    <p className="bold title">Writers ({workDraftFromLocal.writers.length})</p>
                    <span className="small bold blue-text">Required</span>
                </div>
                <div className="cards-wrapper">
                    <div className="cards-field">
                        {workDraftFromLocal.writers.map((data: WriterModel) => (
                            <WriterCardEditable
                                key={data.localId}
                                data={data}
                                removeFunction={removeWriter}
                                errorMessage={
                                    isComposerPresent(workDraftFromLocal.writers)
                                        ? undefined
                                        : 'At least one Composer/Author or Composer writer role is required to submit a work registration.'
                                }
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(WritersSharesRoleStep)
